export const marker = {
  title: 'Gen Studio',
  name: 'Gen',
  position: {
    lat: 41.549402,
    lng: -8.422407
  }
};

export const addressClusters = [
  {
    title: 'Tooltip',
    position: {
      lat: 41.551790,
      lng: -8.421862
    }
  },
  {
    title: 'Tooltip',
    position: {
      lat: 41.549470,
      lng: -8.420914,
    }
  },
  {
    title: 'Tooltip',
    position: {
      lat: 41.551307,
      lng: -8.425867
    }
  }
];

export const countryClusters = [
  {
    label: 'City Name',
    position: {
      lat: 38.716823,
      lng: -9.139949
    }
  },
  {
    label: 'City Name',
    position: {
      lat: 52.076604,
      lng: -0.522302
    }
  },
  {
    label: 'City Name',
    position: {
      lat: 52.256675,
      lng: 13.264371
    }
  }
];

export const countryOrders = [
  {
    origin: { lat: 41.549402, lng: -8.422407 },
    destination: { lat: 21.448213, lng: 78.462239 },
    configured: true
  },
  {
    origin: { lat: 41.549402, lng: -8.422407 },
    destination: { lat: 51.256675, lng: 11.264371 },
    configured: true
  },
  {
    origin: { lat: 21.448213, lng: 78.462239 },
    destination: { lat: 51.256675, lng: 11.264371 },
    configured: true
  },
  {
    origin: { lat: 48.735561, lng: 2.345306 },
    destination: { nr: 351915250476 },
    configured: true
  }
];

export const iconSet = [
  { name: 'devices' },
  { name: 'landline' },
  { name: 'pay-phone' }
];



// WEBPACK FOOTER //
// ./src/containers/components/Map/constants/clustersAndOrders.js